import { graphql } from "relay-runtime"

export const deSickLeaveFragment = graphql`
  fragment deSickLeaveFragment on de_SickLeave {
    id
    fileId
    progressNoteId
    certificateType
    from
    to
    updatedAt
    updatedBy
    createdAt
    createdBy
    concludedAt
    concludedBy
    signedBy
    signedAt
    fileId
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
